import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-67c221fc")

_pushScopeId("data-v-67c221fc")
const _hoisted_1 = { class: "p-m-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_v_chart = _resolveComponent("v-chart")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("h5", _hoisted_1, _toDisplayString(_ctx.$t("datasource.data_size_history.title")), 1),
    _createVNode(_component_v_chart, {
      class: "chart",
      option: _ctx.option,
      theme: _ctx.theme
    }, null, 8, ["option", "theme"])
  ], 64))
})